import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          <Col lg={4} md={6} className="footer-contact">
            <div className="footer-logo">
              <img src="/logo-mr.png" alt="MR Centrifugas" className="footer-logo-img" />
              <h4>MR Centrifugas</h4>
            </div>
            <p className="footer-description">
              Especialistas em manutenção e fabricação de peças para centrifugas e decanters industriais.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>Endereço:</strong><br />
                  Rua Manuel de Teffé 417<br />
                  Jardim Satélite, São Paulo
                </div>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <strong>Telefone:</strong><br />
                  (11) 5660-6431<br />
                  (11) 99780-8507
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>Email:</strong><br />
                  contato@mrcentrifugas.com.br
                </div>
              </div>
            </div>
          </Col>

          <Col lg={2} md={6} className="footer-links">
            <h4>Navegação</h4>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/sobre">Sobre</Link></li>
              <li><Link to="/servicos">Serviços</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contato">Contato</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="footer-links">
            <h4>Serviços</h4>
            <ul>
              <li>Roscas Transportadoras</li>
              <li>Tambor e Eixos</li>
              <li>Redutores</li>
              <li>Decanters</li>
              <li>Manutenção Preventiva</li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="footer-social">
            <h4>Redes Sociais</h4>
            <p>Conecte-se conosco</p>
            <div className="social-links">
              <a href="https://wa.me/5511997808507" target="_blank" rel="noopener noreferrer" className="social-link whatsapp" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
              <button className="social-link facebook" aria-label="Facebook">
                <FaFacebook />
              </button>
              <button className="social-link instagram" aria-label="Instagram">
                <FaInstagram />
              </button>
              <button className="social-link linkedin" aria-label="LinkedIn">
                <FaLinkedin />
              </button>
            </div>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col md={6}>
            <div className="copyright">
              <p>&copy; {currentYear} MR Centrifugas. Todos os direitos reservados.</p>
            </div>
          </Col>
          <Col md={6}>
            <div className="credits">
              <p>
                Desenvolvido por{' '}
                <a href="https://mmtecpay.com.br" target="_blank" rel="noopener noreferrer">
                  MM TECPAY
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 